module.exports = __webpack_public_path__ + "a5e4f879769e0479c8ec463596fd6ff7.svg";